import { useEffect } from "react";

/**
 * Name the browser tab — and the name a phone gives a page saved to its home
 * screen — "Stokkie Stokvel" while a Stokkie Stokvel page is open, and put the old name back
 * on the way out. A stokvel member never signed up to "SmartSpaza", and a tab
 * by that name reads like somebody else's site.
 */
export function useStokkieTitle(): void {
  useEffect(() => {
    const previous = document.title;
    document.title = "Stokkie Stokvel";
    return () => {
      document.title = previous;
    };
  }, []);
}

/** Whether a path belongs to Stokkie Stokvel rather than the shops' SmartSpaza. */
export function isStokkiePath(path: string): boolean {
  return path.startsWith("/stokvel") || path.startsWith("/stokkie");
}
